import { render } from "./DuihuanConfirm.vue?vue&type=template&id=20d8b16a&scoped=true"
import script from "./DuihuanConfirm.vue?vue&type=script&lang=js"
export * from "./DuihuanConfirm.vue?vue&type=script&lang=js"

import "./DuihuanConfirm.vue?vue&type=style&index=0&id=20d8b16a&lang=stylus&scoped=true"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d8b16a"]])

export default __exports__